import { Component, Input } from "@angular/core";
import { DeleteConfirmationComponent } from "@app/directives/_misc/delete-confirm/delete-confirm.component";
import { IAlertRule, IAlertRuleGroupMapping } from "@app/main/modules/alerts/_models/alerts.interfaces";
import { DisplayService, IDialogOptionsJson } from "@app/services/display.service";
import { TranslationService } from "@app/services/translation.service";

@Component({
    selector: 'group-delete-confirmation',
    template: require('./../delete-confirm.component.html')
})
export class GroupDeleteConfirmationComponent extends DeleteConfirmationComponent {

    @Input() groupAlertMapping: IAlertRuleGroupMapping;
    @Input() canBeDeleted: boolean = true;

    constructor(
        displayService: DisplayService,
        translationService: TranslationService
    ) { super(displayService, translationService); }

    showDeleteDialog($event: any): void {
        const dialogHTML = this.buildDialogHtmlString();
        const titleString = this.buildTitleString();

        const dialogOptions: IDialogOptionsJson = {
            title: titleString,
            dialogHTML: dialogHTML,
            dialogId: `deleteConfirmDialog`,
            bindings: {
                onConfirmDialog: (confirmation: boolean) => { this.onConfirmDialog(confirmation); }
            },
            event: $event,
            multiple: true,
            clickOutsideToClose: true,
            escapeToClose: true
        };

        this.displayService.showDialog(dialogOptions);

    }

    private buildTitleString(): string {
        return this.canBeDeleted ? `${this.subjectVerb} ${this.subjectName}?` : this.translationService.t('DeleteConfirm.UnableToDelete', [this.subjectVerb.toLowerCase(), this.subjectName.toLowerCase()]);
    }

    private buildDialogHtmlString(): string {
        let dialogHtmlStringBuilder = [];
        let contextString: string;

        if (!this.canBeDeleted && this.groupAlertMapping?.AlertRules.length === 0) {
            contextString = this.translationService.t('DeleteConfirm.UnableToDeleteNoAccess');
        } else if (!this.canBeDeleted) {
            contextString = this.translationService.t('DeleteConfirm.UnableToDeleteWithAccess');
        } else {
            contextString = this.translationService.t('DeleteConfirm.AreYouSure', [this.subjectVerb.toLowerCase(), this.subjectName.toLowerCase()]);
        }

        dialogHtmlStringBuilder.push(`<veri-panel class="delete-confirm-dialog"><div class="confirm-message">${contextString}</div>`);

        dialogHtmlStringBuilder.push(`<div class="footer"><v-button class="md-secondary" ng-click="$ctrl.onConfirmDialog(false); $ctrl.hide();">${this.cancelVerb}</v-button>`);

        if (this.canBeDeleted) {
            dialogHtmlStringBuilder.push(`<v-button class="danger primary" ng-click="$ctrl.onConfirmDialog(true); $ctrl.hide()">${this.subjectVerb}</v-button>`);
        }

        dialogHtmlStringBuilder.push(`</div></veri-panel>`);

        return dialogHtmlStringBuilder.join(``);
    }
}
